import { createFileRoute } from "@tanstack/react-router";
import { ensureRouteTranslationModuleLoaded } from "@/services/culture/routeTranslationPreload";

export const Route = createFileRoute("/identity-and-access")({
  beforeLoad: async () => {
    await ensureRouteTranslationModuleLoaded("identity-and-access");
  },
  staticData: {
    title: "home.title",
  },
});
